import React, { ReactNode } from 'react';
import { BoschAuthProvider, ThemeProvider } from '@dssf/component-library';
import { HistoryProvider } from './src/contexts/HistoryContext/HistoryContext';

export const scopes = process.env.GATSBY_BOSCH_AUTH_SCOPES?.split(' ').map(scope => scope.trim()) || [];

export function wrapRootElement({ element }: { element: ReactNode }) {
  return (
    <BoschAuthProvider
      clientId={process.env.GATSBY_BOSCH_AUTH_CLIENT_ID!}
      redirectUri={location => process.env.GATSBY_BOSCH_AUTH_REDIRECT_URI!.replace('{host}', location?.hostname ?? '')}
      authority={`https://login.microsoftonline.com/${process.env.GATSBY_BOSCH_AUTH_TENANT_ID}`}
      errorComponent={<h1>Login failed</h1>}
      scopes={scopes}
      enableLocally={true}
    >
      <ThemeProvider>
        <HistoryProvider>{element}</HistoryProvider>
      </ThemeProvider>
    </BoschAuthProvider>
  );
}
